import { AppBar, makeStyles, Toolbar } from '@material-ui/core';
import { Linked, useLinked } from '@type-r/react';
import * as React from 'react';
import { Flex, SearchInput } from 'lqx-react';

export interface OrderSortOptions {
    attr : string
    asc : boolean
}

export interface SearchToolbarProps {
    $filter : Linked<string>
}

export const SearchToolbar = ({ $filter } : SearchToolbarProps ) =>{
    const classes = useStyles();

    const $menuAnchor = useLinked( null ),
        closeMenu = () => $menuAnchor.set( null );

    return (
        <AppBar position="static" color="transparent">
            <Toolbar className={ classes.toolbar }>
                <SearchInput $value={ $filter } />
                <Flex grow />
            </Toolbar>
        </AppBar>
    )
}

const useStyles = makeStyles({
    toolbar : {
        paddingTop: 4,
        paddingBottom: 4,
        minHeight: '32px',
    }
});
